import '@fortawesome/fontawesome-pro-light'
import '@fortawesome/fontawesome-pro-solid'
import { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { updateTenant } from '../store/actions/tenant.actions'
import { getTenant } from '../services/tenant/tenant.service'
import Loading from '../components/Loading/Loading'
import MaestroLogo from '../components/MaestroLogo'
import Footer from '../components/layout/Footer'
import { setDate } from '../store/actions/date.actions'
import Template from '../components/layout/Template'
import { handlerErrorV2 } from '../utils/errors'
import TenantError from '../components/TenantError/TenantError'

const App = () => {
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const getData = useCallback(async () => {
    setLoading(true)
    try {
      const response = await getTenant();
      if (response.error || !response.data) {
        setError(response.error.message || 'Tenant invalid')
      } else {
        navigate('/login')
        dispatch(updateTenant(response.data))
        dispatch(setDate(response.data.date));
      }
    } catch (error) {
      const message = handlerErrorV2(error)
      setError(message)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    getData();
  }, [getData])

  if (error) return <TenantError />
  if (loading) return <Template><Loading /></Template>

  return (
    <div className='h-screen bg-background flex items-center justify-center'>
      <MaestroLogo />
      <Footer />
    </div>
  )
}

export default App